/**
 * Grid Error State Component
 * Displays when there's an error loading sessions
 */

import { AlertCircle, RefreshCw } from 'lucide-react';
import { Button } from '@/core/components/ui/button';

interface GridErrorStateProps {
  title?: string;
  error?: string;
  onRetry?: () => void;
}

export const GridErrorState = ({
  title = 'Failed to Load Sessions',
  error,
  onRetry,
}: GridErrorStateProps) => {
  return (
    <div className="flex flex-col items-center justify-center py-16 px-4">
      <div className="rounded-full bg-red-100 p-4 mb-4">
        <AlertCircle className="h-8 w-8 text-red-500" />
      </div>
      <h3 className="text-lg font-medium text-gray-900 mb-2">{title}</h3>
      {error && (
        <p className="text-sm text-red-600 text-center max-w-md mb-6">
          {error}
        </p>
      )}
      {onRetry && (
        <Button
          onClick={onRetry}
          variant="outline"
          className="flex items-center gap-2"
        >
          <RefreshCw className="h-4 w-4" />
          Try Again
        </Button>
      )}
    </div>
  );
};
